import { useEffect, useState } from "react"
import API from "../api"

/**
 * Fetches activity stats (read/write split, protocol breakdown, hourly distribution) for
 * either a whole host or a single tag on that host, over a given time range.
 *
 * @param {Object|null} payload
 *   - timeFilter: [isoFrom, isoTo]
 *   - ip: string             device ip — always required, scopes to the host
 *   - full_address?: string  when set, narrows the scope down to that single tag
 * @returns {{ data: Object|null, loading: boolean, error: string|null }}
 */
const useOtActivityStats = (payload) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!payload?.ip || !payload?.timeFilter) {
      setData(null)
      setError(null)
      return
    }

    const controller = new AbortController()
    setLoading(true)
    setError(null)

    API.getOtActivityStats(payload, controller.signal)
      .then((res) => setData(res.data ?? null))
      .catch((err) => {
        if (err.name !== "CanceledError" && err.name !== "AbortError") {
          console.error("[useOtActivityStats] Failed to fetch OT activity stats:", err)
          setError(err?.response?.data?.error || err?.message || "Request failed")
        }
      })
      .finally(() => setLoading(false))

    return () => controller.abort()
  }, [JSON.stringify(payload)]) // eslint-disable-line react-hooks/exhaustive-deps

  return { data, loading, error }
}

export default useOtActivityStats
